export function draw(
  definition,
  status,
  currentItemView,
  methods,
) {
  if (status !== 'drawing') return false
  if (!methods.getItem) return false

  //user's end callback
  const onEndDrawing = definition.onEndDrawing
  if (onEndDrawing) onEndDrawing(methods.getItem(currentItemView))
  else return false

  //stop checking of interations
  return true
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseUp/draw.js